module.exports = __webpack_public_path__ + "media/svg-new/quimic-c86a77e4.svg";